const baseTextAreaStyles = (theme) => ({
  backgroundColor: 'transparent',
  fontFamily: 'var(--root-font) !important',
  lineHeight: '1rem',
  width: '100%',
  height: '100%',
  border: 'none',
  '&:focus': {
    outline: 'none'
  },
  '&::placeholder': {
    opacity: '0.2',
    fontWeight: 'bold'
  },
  '&:disabled': {
    resize: 'none'
  }
})

const sizes = {
  xs: (theme, minWidth) => ({
    padding: '2px 2px 2px 2px',
    minHeight: '18px',
    '& > textarea': {
      ...baseTextAreaStyles(theme),
      fontSize: theme.typography.fontSizes.md,
      ...(minWidth && { minWidth })
    }
  }),
  sm: (theme, minWidth) => ({
    padding: '2px 2px 2px 2px',
    minHeight: '32px',
    '& > textarea': {
      ...baseTextAreaStyles(theme),
      fontSize: theme.typography.fontSizes.xl,
      ...(minWidth && { minWidth })
    }
  }),
  lg: (theme, minWidth) => ({
    padding: '9px 2px 9px 2px',
    minHeight: '32px',
    '& > textarea': {
      ...baseTextAreaStyles(theme),
      fontSize: theme.typography.fontSizes.xl,
      ...(minWidth && { minWidth })
    }
  })
}

export const mapInputStyles = (theme, rest) => ({ disabled, size, minWidth }) => ({
  ...rest,
  ...sizes[size](theme, minWidth),
  backgroundColor: disabled ? 'var(--color-neutral-300)' : 'var(--color-surface-050)',
  ...(minWidth && { minWidth })
})
